import base, { firebase } from '../rebase.js';
import { FIREBASEREF_UPLOADS, FIREBASEREF_NEWUPLOADS } from '../globals';

export default function deleteRecord(uploadRec) {
    if (uploadRec.result) {
        firebase.storage().ref(uploadRec.result).delete().then(function () {
            // File deleted successfully
            console.log("Deleted result");
        }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log(error);
        });
    }

    if (uploadRec.result_detailed) {
        firebase.storage().ref(uploadRec.result_detailed).delete().then(function () {
            // File deleted successfully
            console.log("Deleted detailed result");
        }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log(error);
        });
    }

    var haserrorfile = false;
    if (uploadRec.error === "ERROR_INPUTFORMAT") haserrorfile = true;
    else if (uploadRec.error === "ERROR_FLIGHTSNOCAP") haserrorfile = true;
    else if (uploadRec.error === "ERROR_ALREADYFINAL") haserrorfile = true;

    if (haserrorfile) {
        const ref = 'errors/' + uploadRec.tour_operator + '/' + uploadRec.uid + '/' + uploadRec.uploadId;
        firebase.storage().ref(ref).delete().then(function () {
            console.log("Deleted error");
        }).catch(function (error) {
            console.log(error);
        });
    }

    base.remove(FIREBASEREF_NEWUPLOADS + "/" + uploadRec.uploadId).then(function () {
        // File deleted successfully
        console.log("Deleted upload metadata");
    }).catch(function (error) {
        // Uh-oh, an error occurred!
        console.log(error);
    });
    
    base.remove(FIREBASEREF_UPLOADS + "/" + uploadRec.uploadId).then(function () {
        // File deleted successfully
        console.log("Deleted upload metadata");
    }).catch(function (error) {
        // Uh-oh, an error occurred!
        console.log(error);
    });

    firebase.storage().ref(FIREBASEREF_UPLOADS + "/" + uploadRec.tour_operator + '/' + uploadRec.uid + '/' + uploadRec.uploadId).delete().then(function () {
        // File deleted successfully
        console.log("Deleted upload file");
    }).catch(function (error) {
        // Uh-oh, an error occurred!
        console.log(error);
    });
}


// WEBPACK FOOTER //
// ./src/common/DeleteRecord.js